import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Label.module.scss'

/**
 * The `Label`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Label = forwardRef((props, forwardedRef) => {
  const { children, className } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames([className, lineItemStyles.label, styles.label]),
    [className]
  )

  return (
    <div ref={ref} className={classNameOutput}>
      {children}
    </div>
  )
})

// Display name
Label.displayName = 'Label'

/** @type {object} */
Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

/** @type {object} */
Label.defaultProps = {
  children: null,
  className: ''
}

// Memoize
export default memo(Label)
